import { type DentalPlan, type NonMedicalPlanFeature, type OnboardingEnrollment, type PlanCardBadgeCategory, type VisionPlan } from '../types'
import MemberOnboardingPlanCard from './MemberOnboardingPlanCard'
import { PlanCard } from './PlanCard'
import type { PlanCardFeatureProps } from './PlanCard/Features'
import { PlanChip } from './PlanChip'

const getFeaturesMetadata = (features: NonMedicalPlanFeature): PlanCardFeatureProps => {
  const formattedDescription = (
    <ul>
      {features.descriptions.map((item: string) => (
        <li key={item} className='text-gray-800 body-bold'>
          {item}
        </li>
      ))}
    </ul>
  )
  return {
    term: features.header,
    detail: formattedDescription
  }
}

const VisionPlanCard = ({ badgeCategory, displayedPlan, onSelectPlan, currentPlan }: {
  badgeCategory?: PlanCardBadgeCategory,
  displayedPlan: VisionPlan,
  onSelectPlan: (plan: VisionPlan | DentalPlan) => void,
  currentPlan: OnboardingEnrollment | null
}) => {
  const sideBar = (
    <div className='flex flex-col gap-8 w-fit xs:w-36 xs:min-w-36'>
      <PlanChip
        carrierLogo={displayedPlan.carrier_image_url}
        carrierName={displayedPlan.carrier}
        planName={displayedPlan.name}
      />
      <div className='pr-2'>
        <p className='text-gray-500 body'>{displayedPlan.description}</p>
      </div>
    </div>
  )

  const bodyContent = (
    <PlanCard.Features>
      {displayedPlan.features.map((feature) => {
        const featureMetadata = getFeaturesMetadata(feature)
        return (
          <PlanCard.Feature
            term={featureMetadata.term}
            detail={featureMetadata.detail}
            key={feature.header}
          />
        )
      })}
    </PlanCard.Features>
  )

  return (
    <MemberOnboardingPlanCard
      badgeCategory={badgeCategory}
      displayedPlan={displayedPlan}
      currentPlan={currentPlan}
      onSelectPlan={onSelectPlan}
      sidebar={sideBar}
      bodyContent={bodyContent}
      currentType='vision'
    />
  )
}

export default VisionPlanCard
